import requestSender from "./base/requestSender";

export default function(axiosInstance){
    return {
        getCallByClientId(payload){
            return requestSender('get', 'organization/get-call-by-client-id', payload);
        },
        getCallsStat(payload){
            return requestSender('get', 'organization/get-calls-stat', payload);
        },
        getCallsStatExcel(payload, options){
            return requestSender('post', 'organization/get-calls-stat', payload, options);
        },
    }
}